<!--首购订单(经销商)-->
<template>
  <div>
    <app-breadcrumb/>
    <div class="page-container recharge-manage">
      <div v-loading="divLoading">
        <h3 style="color: #b3640d">{{ $t('mall.ProductsList') }}</h3>
        <p style="color:#538E0D; font-size:14px; font-weight:bold;">{{$t('pmEfuboCard.amount')}} <span
            style="color:#F00; font-size:14px; font-weight:bold;">{{ totalfA }}</span> PV <span
            style="color:#F00; font-size:14px; font-weight:bold;">{{ totalFv }}</span></p>
        <el-table
            :data="list"
            v-loading="tableLoading"
            border
            size="mini"
            fit
            highlight-current-row
            style="width: 100%;"
        >
          <!--      商品编码-->
          <el-table-column :label="$t('BiGoods.goodsCode')" prop="goodscode" align="center"/>
<!--          名称-->
          <el-table-column :label="$t('BiGoods.name')" prop="name" align="center"/>
          <!--      价格-->
          <el-table-column :label="$t('pd.price')" prop="standardPrice" align="center"/>
          <!--      积分 busi.direct.sale_points-->
          <el-table-column :label="$t('FV')" prop="standardPv" align="center"/>
          <!--      是否赠品    -->
<!--          <el-table-column :label="$t('Is.it.a.physical.point')" prop="productForm" align="center">-->
<!--            <template v-slot="{row}">-->
<!--              {{$lt(initDict.physicalpoint,row.productForm)}}-->
<!--            </template>-->
<!--          </el-table-column>-->
          <!--      可用库存量-->
          <el-table-column :label="$t('stStock.validQty')" prop="validQty" align="center" >
            <template v-slot="{row}">
              {{$t(StockNumberString(row.validQty))}}
            </template>
          </el-table-column>
          <!--      购买数量-->
          <el-table-column :label="$t('Common.buyNumber')" prop="buyQty" align="center">
            <template v-slot="{row}">
              <el-input v-model.number="row.buyQty"/>
            </template>
          </el-table-column>
        </el-table>
        <el-form label-width="auto" label-position="right">
          <!--         支付密码 -->
          <el-form-item size="mini" style="width: 400px;margin-top: 10px" :label="$t('please.input.your.pay.password')"
                        :rules="{ required: true, message: this.$t('label.pleaseFillIn'), trigger: ['blur', 'change'] }">
            <el-input v-model.trim="listQuery.payPassword" show-password clearable :placeholder="$t('')"/>
          </el-form-item>
        </el-form>
        <IsJoinLowPv ref="isJoinLowPv" :payAmount="Number(totalfA)" /> 
        <div style="text-align: center; margin-bottom: 10px;margin-top: 10px">
          <!--      提交-->
          <el-button size="mini" :loading="btnloading" type="success" icon="el-icon-check" @click="titlesubmit">
            {{ $t('title.submit') }}
          </el-button>
          <!--      取消-->
          <el-button size="mini" :loading="btnloading" type="danger" icon="el-icon-close" @click="buttoncancel">
            {{ $t('operation.button.cancel') }}
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {goodsListSGByMember, saveSG, verificationSG} from "@/api/ay-business-manager/firstpurchaseorder";
import {StockNumberString} from "@/utils/stock-number-string";
import IsJoinLowPv from "@/components/IsJoinLowPv.vue";
export default {
  name: "FirstpurchaseOrder",
  components: { IsJoinLowPv },  
  data() {
    return {
      divLoading: true,
      tableLoading: true,
      listQuery: {
        recType: 1
      },
      list: [],
      btnloading: false,
      initDict:{
        physicalpoint:'Is.it.a.physical.point'
      }
    }
  },
  computed: {
    ...mapGetters([
      'userCode',
      'isAgent',
    ]),
    totalfA() {
      if (!this.list || !this.list.length) {
        return 0
      }
      return this.list.reduce((acc, cur) => {
        return cur.standardPrice * cur.buyQty + acc
      }, 0).toFixed(2)
    },
    totalFv() {
      if (!this.list || !this.list.length) {
        return 0
      }
      return this.list.reduce((acc, cur) => {
        return cur.standardPv * cur.buyQty + acc
      }, 0).toFixed(2)
    },
    buyQty() {
      if (!this.list || !this.list.length) {
        return 0
      }
      return this.list.reduce((acc, cur) => {
        return cur.buyQty + acc
      }, 0)
    }
  },
  created() {
    this.getListSGByMember()
  },
  methods: {
    StockNumberString,
    async getListSGByMember() {
      // 首购单验证
      await verificationSG({'memberNo': this.userCode}).then(() => {
        this.divLoading = false
      }).catch(() => {
        this.$router.push({name: 'OrderQuery'})
        return false
      })
      // 首购单商品列表
      await goodsListSGByMember({'memberNo': this.userCode}).then(res => {
        this.list = res.data
        this.tableLoading = false
      }).catch(() => {})
    },
    // 取消
    buttoncancel() {
      this.$router.push({name: 'OrderQuery'})
    },
    // 提交
    titlesubmit() {

      if (this.$refs.isJoinLowPv.isShow && this.$refs.isJoinLowPv.payAmount >= this.$refs.isJoinLowPv.showAmount) {
        if (!this.$refs.isJoinLowPv.isJoin) {
          this.$message.error(this.$t('poOrder.pleaseChoose'))
          return
        }
        if (this.$refs.isJoinLowPv.isJoin === '0') {
          this.listQuery.isLowPv = 0
        }
        if (this.$refs.isJoinLowPv.isJoin === '1') {
          this.listQuery.isLowPv = 1
        }
      }

      if (this.buyQty <= 0) {
        return this.$message(this.$t('leastInputANumber'))
      }
      if (!this.listQuery.payPassword) {
        return this.$message.error(this.$t('please.input.your.pay.password'))
      } else {
        let lists = []
        for (let i = 0; i < this.list.length; i++) {
          if (this.list[i].buyQty > 0) {
            lists.push(this.list[i])
          }
        }
        this.listQuery.goodsList = lists
        this.btnloading = true
        saveSG({...this.listQuery}).then(() => {
          this.btnloading = false
          this.$router.push({name: 'OrderQuery'})
          this.$message.success(this.$t('bdSendRegister.operaterSuccess'))
        }).catch(err => {
          this.btnloading = false
          console.error(err)
          this.$message.error(this.$t('bdSendRegister.operaterFail'))
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
table {
  margin: 20px 0 20px 0px;
  width: 100%;
  border: 1px solid black;
  border-collapse: collapse;
  text-align: center;

  tr {
    th {
      width: 150px;
      height: 30px;
      line-height: 30px;
      font-size: 18px;
      border: 1px solid black;
    }

    td {
      width: 200px;
      height: 30px;
      line-height: 30px;
      font-size: 18px;
      border: 1px solid black;
    }
  }

  thead {
    th {
      font-size: 18px;
      border-right: 1px solid black;
      width: 400px;
    }
  }

  tbody {
    td {
      overflow: hidden;
      text-overflow: ellipsis;
      word-break: break-all;
      font-size: 14px;
      border: 1px solid black;
      width: 200px;
    }
  }
}
.radio-group {
  label {
    margin: 8px 0;
  }
}
</style>
